import {ProjectBusinessLogicFilterService} from './project-business-logic-filter.service';
import {RestFilterModel} from 'gelios-ng-admin-components';
import {ProjectBusinessLogicFilterModel} from './project-business-logic-filter.model';

export const idAll = -1;

export function formatProjectBusinessLogicFilter(
  selectedProjectId: number | null,
  selectedBusinessLogicId: number | null,
): ProjectBusinessLogicFilterModel {
  return {
    project_id: selectedProjectId !== null && selectedProjectId !== idAll ?
      selectedProjectId : null,
    business_logic_id: selectedBusinessLogicId !== null && selectedBusinessLogicId !== idAll ?
      selectedBusinessLogicId : null,
  };
}

export function extractProjectBusinessLogicFilter(
  filterModel: { [key: string]: any }, model: ProjectBusinessLogicFilterModel
) {
  const filterData = filterModel;
  if (model) {
    if (model.project_id !== null) {
      filterData['project_id'] = model.project_id;
    }
    if (model.business_logic_id !== null) {
      filterData['business_logic_id'] = model.business_logic_id;
    }
  }
  return filterData;
}

export function updateRestFilterModel(
  restFilterModel: RestFilterModel,
  projectBusinessLogicFilter: ProjectBusinessLogicFilterModel
): RestFilterModel {
  const updatedModel: RestFilterModel = {...restFilterModel};

  if (projectBusinessLogicFilter && projectBusinessLogicFilter.project_id !== null) {
    updatedModel['project_id'] = {
      filterType: 'number',
      type: 'equals',
      filter: projectBusinessLogicFilter.project_id,
    };
  } else {
    delete updatedModel['project_id'];
  }

  if (projectBusinessLogicFilter && projectBusinessLogicFilter.business_logic_id !== null) {
    updatedModel['business_logic_id'] = {
      filterType: 'number',
      type: 'equals',
      filter: projectBusinessLogicFilter.business_logic_id,
    };
  } else {
    delete updatedModel['business_logic_id'];
  }

  return updatedModel;
}
